/**
 * Relay v1.6.2
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

module.exports = require('./lib/index.js');



//////////////////
// WEBPACK FOOTER
// ./~/relay-runtime/index.js
// module id = 48
// module chunks = 3